// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__-u-fq","nav":"Footer_nav__VpUi4","icon":"Footer_icon__wh4Mh","name":"Footer_name__8Ra88","active":"Footer_active__WpbqV"};